import { Grid } from '@material-ui/core';
import dayjs from 'dayjs';
import { SimplePopover, SimplePopoverPlainOption } from '@dev/ee-components';
import { Moment } from 'moment';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { monthsArray } from '@/services/tools/getMonthsArray';

const LEAP_YEAR = 2020;

enum SelectionDelimiter {
    Month = 'month',
    Day = 'date',
}

type MonthDaySelectorT = {
    date: Moment;
    ruleValue: string;
    onChange([...args]: any): void;
    classes: any;
};

const getDayOptions = (daysInMonth: number) =>
    [...new Array(daysInMonth || 31)].map((_, idx) => ({
        label: `${idx + 1}`,
        value: idx + 1,
    }));
const monthOptions = monthsArray?.().map((item, idx) => ({ label: item, value: idx + 1 }));

export const MonthDaySelector = ({ date, ruleValue, onChange, classes }: MonthDaySelectorT) => {
    const { t } = useTranslation();

    const month = date?.month?.();
    const daysInMonth = date?.set('year', LEAP_YEAR)?.daysInMonth?.();
    const day = date?.date?.();
    const dayOptions = getDayOptions(daysInMonth);
    const selectionHandler =
        (type: SelectionDelimiter) =>
        (_, { value }: Record<string, number>) => {
            const adjustedValue = type === SelectionDelimiter.Month ? value - 1 : value;

            const newDate = dayjs(ruleValue || new Date().setFullYear(LEAP_YEAR))
                .utc(true)
                .set(type, +adjustedValue)
                .toString();

            onChange(newDate as any);
        };

    return (
        <div className={classes.ruleValueInput}>
            <Grid container spacing={3}>
                <Grid item xs={8}>
                    <SimplePopover
                        value={+month + 1}
                        options={monthOptions as SimplePopoverPlainOption[]}
                        onItemClick={selectionHandler(SelectionDelimiter.Month)}
                        type="input"
                        maxHeight={350}
                        fullWidth
                        defaultPlaceholder={t('selectmonth')}
                    />
                </Grid>
                <Grid item xs={4}>
                    <SimplePopover
                        value={day}
                        options={dayOptions as SimplePopoverPlainOption[]}
                        onItemClick={selectionHandler(SelectionDelimiter.Day)}
                        type="input"
                        maxHeight={350}
                        fullWidth
                        defaultPlaceholder={t('selectday')}
                    />
                </Grid>
            </Grid>
        </div>
    );
};
